<template>
  <section>
     <Form :label-width="150">
       <FormItem  label="渠道门店ID：">
          <p>{{data.channelHotelId}}</p>
        </FormItem>
       <FormItem  label="渠道门店名称：">
          <p>{{data.channelHotelName}}</p>
        </FormItem>
       <FormItem  label="渠道门店编码：">
          <p>{{data.channelHotelName}}</p>
        </FormItem>
       <FormItem  label="渠道房型ID：">
         <p>{{data.channelHotelName}}</p>
       </FormItem>
       <FormItem  label="渠道房型名称：">
         <p>{{data.channelHotelName}}</p>
       </FormItem>
       <FormItem  label="渠道房型编码：">
         <p>{{data.channelHotelName}}</p>
       </FormItem>
       <FormItem  label="匹配状态：">
          <p>{{data.matchStatus}}</p>
        </FormItem>
       <FormItem  label="在线状态：">
          <p>{{data.status === 'S01' ? '已上线' : '已下线'}}</p>
        </FormItem>
        <Button type="primary" @click="openEditInfoModal">编辑房型</Button>
        <Button type="info">重新匹配</Button>
        <Button type="error" @click="updateStatus">{{data.status === 'S01' ? '下线房型' : '上线房型'}}</Button>
     </Form>

     <Modal v-model="editInfoModal.display" ref="editInfoModal" :loading="true" :width="1000" title="修改渠道门店房型信息" @on-ok="preEditInfo" ok-text="提交内容" cancel-text="关闭">
      <Form @submit.native.prevent="preventSubmit" ref="editInfoModalForm" :model="editInfoModal" :rules="rules" :label-width="150">
        <FormItem label="房型名称：" prop="name">
          <Input type="text" v-model="editInfoModal.name"></Input>
        </FormItem>
      </Form>
    </Modal>
  </section>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          name: ''
        };
      }
    }
  },
  data() {
    return {
      editInfoModal: {
        display: false
      },
      rules: {
        channelHotelName: [
          { required: true, message: "房型名称不能为空", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    openEditInfoModal() {
      this.initEditInfoModal();

      this.editInfoModal.display = true;
    },
    initEditInfoModal() {
      this.editInfoModal = Object.assign({}, this.editInfoModal, {
        name: this.data.name
      });
    },
    preEditInfo() {
      let validResult = true;
      this.$refs.editInfoModalForm.validate(valid => {
        validResult = valid;
      });
      if (!validResult) {
        this.$refs.editInfoModal.buttonLoading = false;
        return;
      }
    },
    updateStatus() {
      if (this.data.status === "S01") {
        this.confirmUpdateStatus();
        return;
      }
    },
    confirmUpdateStatus() {
      this.$Modal.confirm({
        title: "提示",
        content: "确定将此门店从渠道下线？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          console.info("下线渠道");
        }
      });
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ota/tujia/roomtype-detail/room-type-info.vue